import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import YumlabCook from "@/pages/yumlab-cook";
import YumlabHome from "@/pages/yumlab-home";
import YumlabNew from "@/pages/yumlab-new";
import YumlabRecipe from "@/pages/yumlab-recipe";
import { Providers } from "@/providers";

function AppRoutes() {
  return (
    <Router>
      <Providers>
        <main>
          <Routes>
            <Route path="/" element={<YumlabHome />} />
            <Route path="/recipes/new" element={<YumlabNew />} />
            <Route path="/recipes/:id" element={<YumlabRecipe />} />
            <Route path="/cook/:id" element={<YumlabCook />} />
          </Routes>
        </main>
      </Providers>
    </Router>
  );
}

export default AppRoutes;
